import { IDR } from '@/libs/currency'
import { DATE, DAY_MONTH_YEAR } from '@/libs/filterDate'

export const columnConfig = [
  {
    key: 'registrasi',
    label: 'Registrasi',
    thStyle: {
      textTransform: 'capitalize',
      fontSize: '14px',
      color: '#333333',
      minWidth: '120px',
      textAlign: 'left',
      fontWeight: 400,
    },
    tdStyle: {
      textTransform: 'capitalize',
      minWidth: '120px',
      textAlign: 'left',
    },
    tdClass: 'text-[#333333]',
  },
  {
    key: 'nama',
    label: 'Nama',
    thStyle: {
      textTransform: 'capitalize',
      fontSize: '14px',
      color: '#333333',
      minWidth: '180px',
      textAlign: 'left',
      fontWeight: 400,
    },
    tdStyle: {
      textTransform: 'capitalize',
      minWidth: '180px',
      textAlign: 'left',
    },
    tdClass: 'text-[#333333]',
  },
  {
    key: 'email',
    label: 'Email',
    thStyle: {
      textTransform: 'capitalize',
      fontSize: '14px',
      color: '#333333',
      minWidth: '180px',
      textAlign: 'left',
      fontWeight: 400,
    },
    tdStyle: {
      textTransform: 'capitalize',
      minWidth: '180px',
      textAlign: 'left',
    },
    tdClass: 'text-[#333333]',
  },
  {
    key: 'no_hp',
    label: 'No HP',
    thStyle: {
      textTransform: 'capitalize',
      fontSize: '14px',
      color: '#333333',
      minWidth: '150px',
      textAlign: 'left',
      fontWeight: 400,
    },
    tdStyle: {
      textTransform: 'capitalize',
      minWidth: '150px',
      textAlign: 'left',
    },
    tdClass: 'text-[#333333]',
  },
  {
    key: 'ctwa',
    label: 'CTWA',
    thStyle: {
      textTransform: 'capitalize',
      fontSize: '14px',
      color: '#333333',
      minWidth: '120px',
      textAlign: 'center',
      fontWeight: 400,
    },
    tdStyle: {
      textTransform: 'capitalize',
      minWidth: '120px',
      textAlign: 'center',
    },
  },
  {
    // Whitelisted - Google
    key: 'whitelist_google',
    label: '',
    group: 'whitelisted',
    thStyle: {
      textTransform: 'capitalize',
      fontSize: '14px',
      color: '#333333',
      minWidth: '80px',
      textAlign: 'center',
      fontWeight: 400,
      justifyContent: 'center',
    },
    tdStyle: {
      textTransform: 'capitalize',
      minWidth: '80px',
      textAlign: 'center',
    },
  },
  {
    // Whitelisted - Meta
    key: 'whitelist_meta',
    label: '',
    group: 'whitelisted',
    thStyle: {
      textTransform: 'capitalize',
      fontSize: '14px',
      color: '#333333',
      minWidth: '80px',
      textAlign: 'center',
      fontWeight: 400,
      justifyContent: 'center',
    },
    tdStyle: {
      textTransform: 'capitalize',
      minWidth: '80px',
      textAlign: 'left',
    },
  },
  {
    // Whitelisted - TikTok
    key: 'whitelist_tiktok',
    label: '',
    group: 'whitelisted',
    thStyle: {
      textTransform: 'capitalize',
      fontSize: '14px',
      color: '#333333',
      minWidth: '80px',
      textAlign: 'center',
      fontWeight: 400,
      justifyContent: 'center',
    },
    tdStyle: {
      textTransform: 'capitalize',
      minWidth: '80px',
      textAlign: 'left',
    },
  },
  {
    key: 'detail',
    label: '',
    thStyle: {
      textTransform: 'capitalize',
      fontSize: '14px',
      color: '#333333',
      minWidth: '80px',
      textAlign: 'left',
      fontWeight: 400,
    },
    tdStyle: {
      textTransform: 'capitalize',
      minWidth: '80px',
      textAlign: 'left',
    },
  },
]

export const chartOptions = {
  series: [],
  resetSeries: {
    shouldUpdateChart: true,
  },
  chart: {
    type: 'area',
    stacked: false,
    height: 350,
    toolbar: { show: false },
    zoom: { enabled: true },
    fontFamily: 'Poppins, sans-serif',
  },
  dataLabels: {
    enabled: false,
  },
  yaxis: {
    labels: {
      formatter: val => IDR(Math.abs(val), 2, 2),
    },
  },
  xaxis: {
    type: 'category',
    categories: [],
    tickAmount: 31,
    labels: {
      formatter: value => DATE(value),
    },
  },
  grid: {
    row: {
      colors: ['#f3f3f3', 'transparent'],
      opacity: 0.5,
    },
  },
  colors: ['#F95031'],
  legend: {
    show: false,
  },
  noData: { text: 'Tidak Ada Data' },
  tooltip: {
    custom({
      series, seriesIndex, dataPointIndex, w,
    }) {
      const dateValue = DAY_MONTH_YEAR(w.config.xaxis.min[dataPointIndex])

      // Format the tooltip content
      return `
        <div class="custom-tooltip" style="
          background: white;
          border-radius: 8px;
          padding: 12px;
          box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
          border: 1px solid #E5E5E5;
          font-family: 'Poppins', sans-serif;
        ">
          <div style="font-weight: 600; color: #333; margin-bottom: 4px;">
            Tanggal: ${dateValue || 'Tidak ada data'}
          </div>
          <div style="font-weight: 500; color: #F95031;">
            ${IDR(Math.abs(series[seriesIndex][dataPointIndex]))}
          </div>
        </div>
      `
    },
  },
}
